import { Box, Typography } from "@mui/material";
import { ReactComponent as PodcastIcon } from "../../static/svg/old-podcast-white-icon.svg";
import PodcastPlatformLinks from "./PodcastPlatformLinks";

type Props = {};

const PodcastSubscribe = (props: Props) => {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: 400, sm: 500, md: 400 },
        width: { xs: "90%", sm: "90%", md: "89%" },
        justifySelf: "center",
        mt: 2,
        mb: 10,
      }}
    >
      <Box
        className="card-bg"
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(https://mh-resources-production.s3.us-west-1.amazonaws.com/siblingsCaf.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: 400, sm: 500, md: 400 },
          borderRadius: 4,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "black",
          opacity: 0.52,
          borderRadius: 4,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
        }}
      >
        <PodcastIcon className="mx-auto" />
        <Box display="grid" justifyContent="center" py={3}>
          <Typography
            variant="h2"
            fontSize={{ xs: "32px", sm: "56px", md: "64px" }}
            lineHeight={{ xs: "103%", sm: "105.5%" }}
            letterSpacing={"-0.05em"}
            color={"white"}
            className="text-center py-1"
          >
            Subscribe to the Podcast
          </Typography>
          <Typography
            variant="caption"
            fontSize={{ xs: "8px", sm: "12px", md: "12px" }}
            lineHeight={{ xs: "103%", sm: "189%" }}
            letterSpacing={"0.1em"}
            className="text-center"
            color={"white"}
          >
            Listen to the latest episode every Wednesday{" "}
          </Typography>
        </Box>

        <Box mt={3} display="grid" justifyContent="center">
          <PodcastPlatformLinks
            spotifyUrl="https://open.spotify.com/show/43MizJhEeMXjPQG2afWoxR"
            appleUrl="https://podcasts.apple.com/gb/podcast/homefront/id1886391851"
            googleUrl="https://youtube.com/playlist?list=PLhQkIzHrjgtF4XHgnYW5QEs-vts6Etkax&si=iu2c4EWZ7Rx2lWub"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PodcastSubscribe;
